import React from 'react';
import { at } from 'lodash';
import { useField, Form, FormikProps, Formik } from 'formik';
import TextField from '@mui/material/TextField';

export default function InputField(props:any) {

    
  const { errorText, ...rest } = props;
  const [field, meta, isdisabled] = useField(props);
  


  function _renderHelperText() {
    const [touched, error] = at(meta, 'touched', 'error');
   
    if (touched && error) {
        if (typeof error === 'object' && error !== null) {
            return Object.values(error).find(v => typeof v === 'string') || "Campo requerido";
        }
        return error;
    }
    if (touched && props.required && (!field.value || field.value === '')) {
        return "Campo requerido";
    }
  }

  return (
    <TextField
      autoComplete='off'
      error={Boolean((meta.touched && meta.error) || (meta.touched && props.required && (!field.value || field.value === '')))}
      helperText={_renderHelperText()}
      {...field}
      {...rest}
    />
  );
}
